// Guest action intent capture (2026-07).
//
// A logged-out visitor who presses "Offer help" or "Apply" used to be dumped
// on /login with no memory of what they came to do — after signing up they
// landed on the dashboard and had to find the thing again. Most don't.
//
// This stores the full path to return to (including a query flag the target
// page reads to resume the action, e.g. /opportunities/x?apply=1), and the
// three post-auth redirect points consume it: Login.finishAuth, AuthCallback
// (Google) and Onboarding (brand-new accounts, which route through onboarding
// before anything else).
//
// Deliberately generic: the older collective-specific `civic_return_join` flag
// still works and is checked alongside this, so no existing flow changed.
// sessionStorage (not localStorage) — an abandoned intent shouldn't outlive
// the browser session.
const KEY = "civic_return_to";

// Only same-origin app paths, so a crafted link can never bounce a user
// off-site after login.
function safe(path) {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//");
}

export function rememberReturn(path) {
  if (!safe(path)) return;
  try { sessionStorage.setItem(KEY, path); } catch { /* private mode */ }
}

export function peekReturn() {
  try {
    const v = sessionStorage.getItem(KEY);
    return safe(v) ? v : null;
  } catch { return null; }
}

export function takeReturn() {
  const v = peekReturn();
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  return v;
}
